import { render, staticRenderFns } from "./portForward.vue?vue&type=template&id=0c124c44&scoped=true&"
import script from "./portForward.vue?vue&type=script&lang=js&"
export * from "./portForward.vue?vue&type=script&lang=js&"
import style0 from "./portForward.vue?vue&type=style&index=0&id=0c124c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c124c44",
  null
  
)

export default component.exports